import { Getters } from "vuex-smart-module";
import UserAdminState from "./state";

export default class UserAdminGetters extends Getters<UserAdminState> {
  get usersLoaded() {
    return !!this.state.userList.length;
  }
  getUserByID(id: number) {
    return this.state.userList.find((user) => user.id === id);
  }
  get userList() {
    return this.state.userList;
  }
  get tokenList() {
    return this.state.availableTokenList;
  }
}
